import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Login from './Login';
import Register from './Register';
import Forgot from './Forgot';
import Authenticated from './Authenticated/Authenticated';
import { translate } from '../../utils/locale';
import s from './Account.scss';

const Account = ({ setup, checkout }) => {
	const [view, toggleView] = useState('login');

	const toggleViewHandler = (e) => {
		e.preventDefault();
		const nextView = e.currentTarget.getAttribute('href').slice(1);
		window.scrollTo(0, 0);
		toggleView(nextView);
	};

	if (!checkout?.account?.loggedIn) {
		if (view === 'register') {
			return (
				<div className={s.account}>
					<h1 className={s.account_title}>{ translate(setup, 'accountRegisterTitle') }</h1>
					<Register setup={setup} checkout={checkout} toggleView={toggleViewHandler} />
				</div>
			);
		}

		if (view === 'forgot-password') {
			return (
				<div className={s.account}>
					<h1 className={s.account_title}>{ translate(setup, 'accountForgotTitle') }</h1>
					<Forgot setup={setup} checkout={checkout} toggleView={toggleViewHandler} />
				</div>
			);
		}

		return (
			<div className={s.account}>
				<h1 className={s.account_title}>{ translate(setup, 'accountLogInTitle') }</h1>
				<Login setup={setup} checkout={checkout} toggleView={toggleViewHandler} />
			</div>
		);
	}

	return (
		<div className={s.account}>
			<h1 className={s.account_title}>{ translate(setup, 'accountAuthenticatedTitle').replace('%name%', checkout.payment.address.firstName) }</h1>
			<Authenticated setup={setup} checkout={checkout} />
		</div>
	);
};

const mapState = ({ checkout, environment }, { restrictedPage = false }) => (
	{
		checkout,
		setup: environment.setup,
		restrictedPage,
	}
);

export default hot(module)(connect(mapState)(Account));
